export default __webpack_public_path__ + "static/media/website.92645082.svg";